import { createAction } from '@reduxjs/toolkit';

export const clearOpenShiftRequestError = createAction('openshiftRequests/clearError');
